export function parseInputNumberOrNull(inputEl, fallbackValue = null) {
  if (!(inputEl instanceof HTMLInputElement)) {
    return fallbackValue;
  }

  const raw = String(inputEl.value || "").trim();
  if (!raw) {
    return null;
  }

  const normalized = raw.replaceAll(",", ".");
  const value = Number(normalized);
  return Number.isFinite(value) ? value : fallbackValue;
}

export function hasFilledNumericInput(inputEl) {
  if (!(inputEl instanceof HTMLInputElement)) {
    return false;
  }

  const raw = String(inputEl.value || "").trim();
  if (!raw) {
    return false;
  }

  const parsed = Number(raw.replaceAll(",", "."));
  return Number.isFinite(parsed);
}
